if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.subscribeVariantSwap();
        this.bindSizeHelpEscape();
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      /*
        AFTER FIVE: variant-dependent fragments. Any element of this product section that has the
        attribute data-af-variant-swap and an id ending in "-<section id>" (the pre-order note, the
        delivery and returns facts, the sticky add-to-cart bar) takes its content from the section
        HTML that variant-radios fetches on every variant change. Those fragments are rendered by
        Liquid only and never recomputed in JavaScript. In the quick-add panel the section id is
        prefixed with "quickadd-", so only the panel's own fragments are touched.
      */
      subscribeVariantSwap() {
        if (this.variantSwapUnsubscriber || typeof subscribe !== 'function') return;
        this.variantSwapUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const originalSection = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (!event.data || event.data.sectionId !== originalSection || !event.data.html) return;
          // A quick-add panel opened on a product page shares this section id: only take HTML rendered for this product.
          const sourceInfo = event.data.html.querySelector('product-info');
          if (sourceInfo && sourceInfo.dataset.url !== this.dataset.url) return;
          const suffix = `-${this.dataset.section}`;
          document.querySelectorAll('[data-af-variant-swap][id]').forEach((target) => {
            if (!target.id.endsWith(suffix)) return;
            // "X-quickadd-<id>" also ends with "-<id>": leave the panel's fragments to the panel.
            if (!this.dataset.originalSection && target.id.endsWith(`-quickadd${suffix}`)) return;
            const sourceId = target.id.slice(0, target.id.length - suffix.length) + `-${originalSection}`;
            const source = event.data.html.getElementById(sourceId);
            if (source) target.innerHTML = source.innerHTML;
          });
        });
      }

      /*
        The Size help dialog closes on Escape through the theme's modal-dialog while focus is inside
        it. Third-party widgets (the newsletter teaser) can take focus away after it opens; Escape
        still has to close it.
      */
      bindSizeHelpEscape() {
        if (window.afSizeHelpEscapeBound) return;
        window.afSizeHelpEscapeBound = true;
        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const dialog = document.querySelector('modal-dialog.af-size-help[open]');
          if (dialog && !dialog.contains(document.activeElement)) dialog.hide();
        });
      }

      disconnectedCallback() {
        if (this.variantSwapUnsubscriber) {
          this.variantSwapUnsubscriber();
          this.variantSwapUnsubscriber = undefined;
        }
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
